import { render, staticRenderFns } from "./timeControll.vue?vue&type=template&id=83013bbc&scoped=true&"
import script from "./timeControll.vue?vue&type=script&lang=js&"
export * from "./timeControll.vue?vue&type=script&lang=js&"
import style0 from "./timeControll.vue?vue&type=style&index=0&id=83013bbc&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83013bbc",
  null
  
)

export default component.exports